export default function GiftingLimitReached(): React.ReactElement {
  return (
    <p className="font-poppins text-base">
      {
        "You've already gifted the maximum of 5 premium stories. Try again in the next month."
      }
    </p>
  );
}
